import React from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import './TimecardFollowup.css';
import ClientServicesGrid from "../../Components/TimeCardFollowUpGrid/ClientServicesGrid";
import { Button, Layout, message, Select, Tooltip } from "antd";
const { Header, Content } = Layout;

const ClientServices = () => {
    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                    <Header className="preview-header-class"><Navbar /></Header>
                    <Content>
                        <div>
                            <div className="timesheet-first-div">
                                <h1 className="timesheet-title">Client Services</h1>
                            </div>
                            <div className="timesheet-second-div">
                                <label className="label-timesheet">VMS Client</label>
                                <Select className="dropdown-timesheet" placeholder="Select VMS">
                                    <Option>Agile</Option>
                                </Select>
                                <label className="label-timesheet">Payroll Type</label>
                                <Select className="dropdown-timesheet" placeholder="Select PayrollType">
                                    <Option>Weekly</Option>
                                    <Option>Bi-Weekly</Option>
                                </Select>
                            </div>
                            <ClientServicesGrid />
                            
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default ClientServices;